<!--
@Time : 2020/11/26 4:28 上午
@Author : yekong
@File : title.vue
@Software : PhpStorm
-->
<template>
  <div class="title">
    <p>{{ title }}</p>
    <slot></slot>
    <div class="line">
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "title",
  data: function () {
    return {}
  },
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 100%;
  height: 160px;
  p{
    flex-shrink: 0;
    padding-right: 40px;
  }

  .line {
    height: 2px;
    background: #979797;
    width: 100%;
    position: relative;

    span {
      width: 120px;
      height: 10px;
      background: #FFFFFF;
      display: block;
      position: absolute;
      right: 0;
      top: -5px;
    }
  }
}
</style>
